import { memo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { MOVE_DOWN, MOVE_UP, REMOVE } from './types';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { Flex } from 'foundations-components/components/Flex';
import { UpIcon, DownIcon, RemoveIcon } from 'foundations-assets';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getButtonTooltip = (type, disabled, uploadsInProgress) => {
  if (!disabled || uploadsInProgress) {
    return null;
  }
  if (type === 'up') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.PropertyInputFilesV2.upButtonDisableTooltip"
    });
  }
  if (type === 'down') {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "customerDataProperties.PropertyInputFilesV2.downButtonDisableTooltip"
    });
  }
  return null;
};
const FileActions = ({
  fileId,
  disabled,
  index,
  totalFiles,
  uploadsInProgress,
  onFileAction
}) => {
  const disableUpButton = index === 0 || disabled;
  const disableDownButton = index === totalFiles - 1 || disabled;
  const disableRemoveButton = disabled;
  return /*#__PURE__*/_jsxs(Flex, {
    alignItems: "center",
    marginInlineEnd: "200",
    children: [/*#__PURE__*/_jsx(IconButton, {
      size: "small",
      use: "link",
      disabled: disableUpButton,
      onClick: () => onFileAction({
        action: MOVE_UP,
        fileId
      }),
      tooltip: getButtonTooltip('up', disableUpButton, uploadsInProgress),
      children: /*#__PURE__*/_jsx(UpIcon, {})
    }), /*#__PURE__*/_jsx(IconButton, {
      size: "small",
      use: "link",
      disabled: disableDownButton,
      onClick: () => onFileAction({
        action: MOVE_DOWN,
        fileId
      }),
      tooltip: getButtonTooltip('down', disableDownButton, uploadsInProgress),
      children: /*#__PURE__*/_jsx(DownIcon, {})
    }), /*#__PURE__*/_jsx(IconButton, {
      size: "extra-small",
      use: "link",
      disabled: disableRemoveButton,
      onClick: () => onFileAction({
        action: REMOVE,
        fileId
      }),
      children: /*#__PURE__*/_jsx(RemoveIcon, {})
    })]
  });
};
export default /*#__PURE__*/memo(FileActions);